import React, {useContext, useEffect, useRef, useState} from "react";
import {SliderContext} from "./Slider";
import styles from './SliderList.module.css'
import Slide from "./Slide";
import useWindowSize from "../Hook/UseWindowSize";
import TariffFilter from "../TarifFilter/TariffFilter";
import {Link, useLocation} from "react-router-dom";

export default function SlideList() {
    const location = useLocation()
    const context = useContext(SliderContext);

    const showSlide = (slide: any ,ind:number)=>{
        return (
            <div key={ind} className={styles.slCont}>
                <Slide item={slide} showConnect={true}/>
            </div>
        )
    }

    if(context?.slidesCount === 0)
        return (
            <div className={styles.sliderContainer}  >
                <div  className={styles.notFound}>По заданным условиям тарифов не найдено</div>
            </div>

        )


    const buildDummy = (len:number,line:number)=>{
        if( len <= 0 || line <=0) return null
        const arr = Array(len).fill(0)
        return(
            arr?.map((item,idx)=>{
                return(
                    <div key={idx} className={styles.dummyItem}></div>
                )
            })

        )
    }

    const buildLineContent = (slideLine: any[], key:number, maxLen:number)=>{
        if(!Array.isArray(slideLine))return null
        return(
            <div className={styles.sliderContainer} key={key} >
                <div key={key} className={[styles.sliderList, styles.header].join(' ')}  >
                    {
                        slideLine.map((slide:any, index:number) => {
                        //console.log(`index ${index} cnt ${Number(cnt) } slider ${context?.slideNumber}`)
                            return showSlide(slide,index)
                        })

                    }
                    {buildDummy(context?.screenSlideCount - slideLine?.length,key)}
                </div>
            </div>

        )
    }

    const build = ()=>{
        return context.itemList?.map((item:any,idx:number)=>{
            return buildLineContent(item,idx,context.screenSlideCount )
        })
    }
//    console.log("refresh ", context?.refresh)
    return (
        <div className={styles.allCont}>
            {build()}
        </div>
    )

}


